import React, {Fragment, useEffect } from 'react';
import Navbar from './components/layout/Navbar';
import Landing from './components/layout/Landing';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './components/auth/Login';
import Register2 from './components/auth/Register2';
import Alert from './components/layout/Alert';
import Dashboard from './components/dashboard/Dashboard';
import TSchedule from './components/profile-forms/TSchedule';
import Dload from './components/dashboard/Dload';
import Dload2 from './components/dashboard/Dload2';

import PrivateRoute from './components/routing/PrivateRoute';

// Redux
import {Provider} from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';

import './App.css';
import setAuthToken from './utils/setAuthToken';



if(localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => { 
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return(
  <Provider store = {store}>
  <Router>
    <Fragment>
      <Navbar />
      
      <Route exact path="/" component = { Landing } />
      <section className="container">
      
        <Switch>
          <Route exact path = "/register" component = { Register2 } />
          <Route exact path = "/login" component = { Login } />
          <PrivateRoute exact path = '/dashboard' component = { Dashboard } />
          
          {/* <PrivateRoute exact path = '/verify' component = {VDash} />
          <PrivateRoute exact path = '/update' component = {UDash} />
          <PrivateRoute exact path = '/attend' component = {ADash} />
          <PrivateRoute exact path = '/edit-details' component = {EditCandidate} />
          <PrivateRoute exact path = '/coord' component = {CDash} />

          <PrivateRoute exact path = '/rank' component = {RDash} />
          <PrivateRoute exact path = "/random" component = {RandDash} />

          <PrivateRoute exact path = "/report" component = {ReportDash} />
          <PrivateRoute exact path = "/download" component = {Pview} />
          <PrivateRoute exact path = "/pending" component = {Pending} />
          <PrivateRoute exact path = "/admin" component = {AdminDash} />
          
          <PrivateRoute exact path = "/schedule" component = {TSchedule} /> */}
          <PrivateRoute exact path = "/dload" component = {Dload} />
          {/* <PrivateRoute exact path = "/vudload" component = {Dload2} />

          <PrivateRoute exact path = "/repdown" component = {Preport} />

          <PrivateRoute exact path = "/checkstatus" component = {TFCSelect} /> */}

        </Switch>
        <Alert />
      </section>
    </Fragment>
  </Router> 
  </Provider> 
);
  }

export default App;
